import _defineProperty from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import variables from '@/styles/element-variables.scss';
import defaultSettings from '@/settings';
import weforsys from '@/utils/weforsys';
var showSettings = defaultSettings.showSettings,
  tagsView = defaultSettings.tagsView,
  tagsIcon = defaultSettings.tagsIcon,
  showLanguage = defaultSettings.showLanguage,
  showSearch = defaultSettings.showSearch,
  useCache = defaultSettings.useCache,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo,
  themeClass = defaultSettings.themeClass,
  slideClass = defaultSettings.slideClass,
  layoutType = defaultSettings.layoutType;
var state = {
  theme: variables.theme,
  showSettings: showSettings,
  tagsView: weforsys.storageGet('tagsView') === null ? tagsView : weforsys.storageGet('tagsView'),
  tagsIcon: weforsys.storageGet('tagsIcon') === null ? tagsIcon : weforsys.storageGet('tagsIcon'),
  showLanguage: weforsys.storageGet('showLanguage') === null ? showLanguage : weforsys.storageGet('showLanguage'),
  showSearch: weforsys.storageGet('showSearch') === null ? showSearch : weforsys.storageGet('showSearch'),
  useCache: weforsys.storageGet('useCache') === null ? true : weforsys.storageGet('useCache'),
  fixedHeader: weforsys.storageGet('fixedHeader') === null ? fixedHeader : weforsys.storageGet('fixedHeader'),
  sidebarLogo: weforsys.storageGet('sidebarLogo') === null ? sidebarLogo : weforsys.storageGet('sidebarLogo'),
  themeClass: weforsys.storageGet('themeClass') === null ? themeClass : weforsys.storageGet('themeClass'),
  slideClass: weforsys.storageGet('slideClass') === null ? slideClass : weforsys.storageGet('slideClass'),
  layoutType: weforsys.storageGet('layoutType') === null ? layoutType : weforsys.storageGet('layoutType'),
  fullscreenDom: null
};
var mutations = {
  setToggleTag: function setToggleTag(state, val) {
    state.fullscreenDom = val;
  },
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
      weforsys.storageSet(_defineProperty({}, key, value));
    }
  }
};
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit('CHANGE_SETTING', data);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};